exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ofpp-wrap{\r\n    position: relative;\r\n    display:d-flex;\r\n    \r\n    float:left;\r\n\r\n\r\n    text-align: center;\r\n\r\n\r\n\r\n}\r\n.XXXofpp-row1{\r\n  \r\n    width:100%;\r\n}\r\n\r\n\r\n\r\n.ofpp-row2{\r\n\r\n    width:100%;\r\n}\r\n\r\n.ofpp-toggle{\r\n    width:100%;\r\n    display:inline-block;\r\n\r\n}\r\n", ""]);

